const axios = require('axios');
module.exports.init = me => {
  me.fetchProfile = (on_success, on_failure) => {
    axios.post(`${me.config.url}/auth/me`, {}, {
      headers: {
        Authorization: `Bearer ${me.access_token}`
      }
    }).then(response => {
      on_success(response.data);
    }).catch(response => {
      console.log(response);
      if (response.response.status === 401) me.on_auth_error();
      on_failure(response);
    });
  };
};